export enum ProcurementArea {
  Other = 0,
  Storage = 1,
  Medicine = 2,
  // Provision = 3,
  Supplier = 4,
}
